export const sessionStorageKeys = {
  scheduleVersion: 'scheduleVersion',
  forbiddenRedirectFrom: 'forbiddenRedirectFrom',
  forbiddenCause: 'forbiddenCause',
};

export const localStorageKeys = {
  theme: 'theme',
  language: 'language',
  filtersCollapsed: 'filtersCollapsed',
  navCollapsed: 'navCollapsed',
  mutedVehicles: 'mutedVehicles',
  layoutColumns: 'layoutColumns',
  healthCheckLandingView: 'healthCheckLandingView',
  statusItemsFilters: 'statusItemsFilters',
  statusItemsSorting: 'statusItemsSorting',
  workItemSorting: 'workItemSorting',
  workItemsFilters: 'workItemsFilters',
  journeySorting: 'journeySorting',
  journeyDraft: 'journeyDraft',
  journeyDraftPending: 'journeyDraftPending',
  differenceCheckerFilters: 'differenceCheckerFilters',
  washingFilters: 'washingFilters',
  healthCheckSettingsShowReference: 'healthCheckSettingsShowReference',
};

export const localStorageResettableKeys = [
  localStorageKeys.statusItemsFilters,
  localStorageKeys.statusItemsSorting,
  localStorageKeys.workItemSorting,
  localStorageKeys.journeySorting,
  localStorageKeys.mutedVehicles,
  localStorageKeys.workItemsFilters,
  localStorageKeys.layoutColumns,
  localStorageKeys.healthCheckLandingView,
  localStorageKeys.navCollapsed,
  localStorageKeys.filtersCollapsed,
  localStorageKeys.washingFilters,
  // legacy keys
  'statusItemsContracts',
  'contracts',
  'contractGroups',
];

export const clearLocalStorageResettableKeys = () => {
  localStorageResettableKeys.forEach((key) => {
    localStorage.removeItem(key);
  });
};
